import { AccordionComponent } from '../../../../../ReusableComponents/Accordion/AccordionComponent';
import { ButtonComponent } from '../../../../../ReusableComponents/Button/ButtonComponent';
import { PopoverComponent } from '../../../../../ReusableComponents/Popover/PopoverComponent';
import React, {
  ChangeEvent,
  FunctionComponent,
  memo,
  MutableRefObject,
} from 'react';
import { RadioComponent } from '../../../../../ReusableComponents/Radio/RadioComponent';
import { MdExpandMore } from 'react-icons/md';
import { Slider } from '@material-ui/core';
import './CapacityStoreFilterPopover.scss';
interface Props {
  filterRadioCapacity: string;
  setFilterRadioCapacityCallback: (
    event: ChangeEvent<HTMLInputElement>
  ) => void;
  filterRadioActiveInactiveStores: string;
  setFilterRadioActiveInactiveStoresCallback: (
    event: ChangeEvent<HTMLInputElement>
  ) => void;
  cutoffTimeVisualRange: number | number[];
  setCutoffTimeRangeCallback: (
    event: ChangeEvent<Record<any, any>>,
    newValue: number | number[]
  ) => void;
  setCutoffVisualChangeCallback: (
    event: ChangeEvent<Record<any, any>>,
    newValue: number | number[]
  ) => void;
  timeRangeValueText: (value: number) => string;
  filterButtonRef: MutableRefObject<HTMLButtonElement | undefined>;
  onClosePopover: () => void;
  isPopoverVisible: boolean;
  clearAllFilter: () => void;
}

const CapacityStoreFilterPopover: FunctionComponent<Props> = memo(props => {
  const {
    filterRadioCapacity,
    setFilterRadioCapacityCallback,
    filterRadioActiveInactiveStores,
    setFilterRadioActiveInactiveStoresCallback,
    cutoffTimeVisualRange,
    setCutoffTimeRangeCallback,
    setCutoffVisualChangeCallback,
    timeRangeValueText,
    filterButtonRef,
    onClosePopover,
    isPopoverVisible,
    clearAllFilter,
  } = props;
  const filterAccordionList = [
    {
      accordionSummary: {
        element: (
          <div>
            <span>Capacity</span>
          </div>
        ),
      },
      accordionDetails: {
        element: (
          <div className="filter-capacity-radio-section">
            <RadioComponent
              checked={filterRadioCapacity === ''}
              name="filter-capacity"
              id="filter-capacity"
              label={{ node: 'All' }}
              onChange={setFilterRadioCapacityCallback}
              value=""
            />
            <RadioComponent
              checked={filterRadioCapacity === 'fullCapacity'}
              name="filter-capacity"
              id="filter-capacity"
              label={{ node: 'Full capacity' }}
              onChange={setFilterRadioCapacityCallback}
              value="fullCapacity"
            />
            <RadioComponent
              checked={filterRadioCapacity === 'availableCapacity'}
              name="filter-capacity"
              id="filter-capacity"
              label={{ node: 'Available capacity' }}
              onChange={setFilterRadioCapacityCallback}
              value="availableCapacity"
            />
          </div>
        ),
      },
      expandIcon: <MdExpandMore />,
    },
    {
      accordionSummary: {
        element: (
          <div>
            <span>Active/Inactive Stores</span>
          </div>
        ),
      },
      accordionDetails: {
        element: (
          <div className="filter-active-inactive-stores-section">
            <RadioComponent
              checked={filterRadioActiveInactiveStores === ''}
              name="filter-active-inactive-stores"
              id="filter-active-inactive-stores"
              label={{ node: 'All' }}
              onChange={setFilterRadioActiveInactiveStoresCallback}
              value=""
            />
            <RadioComponent
              checked={filterRadioActiveInactiveStores === 'active'}
              name="filter-active-inactive-stores"
              id="filter-active-inactive-stores"
              label={{ node: 'Active' }}
              onChange={setFilterRadioActiveInactiveStoresCallback}
              value="active"
            />
            <RadioComponent
              checked={filterRadioActiveInactiveStores === 'inactive'}
              name="filter-active-inactive-stores"
              id="filter-active-inactive-stores"
              label={{ node: 'Inactive' }}
              onChange={setFilterRadioActiveInactiveStoresCallback}
              value="inactive"
            />
          </div>
        ),
      },
      expandIcon: <MdExpandMore />,
    },
    {
      accordionSummary: {
        element: (
          <div>
            <span>Cutoff times</span>
          </div>
        ),
      },
      accordionDetails: {
        element: (
          <div className="filter-cutoff-time-section">
            <Slider
              value={cutoffTimeVisualRange}
              onChangeCommitted={setCutoffTimeRangeCallback}
              onChange={setCutoffVisualChangeCallback}
              valueLabelDisplay="on"
              min={0}
              max={23}
              aria-labelledby="range-slider"
              getAriaValueText={timeRangeValueText}
              valueLabelFormat={timeRangeValueText}
            />
          </div>
        ),
      },
      expandIcon: <MdExpandMore />,
    },
  ];

  return (
    <PopoverComponent
      className="filter-popover"
      anchorEl={filterButtonRef.current}
      id="filter-popover"
      onClose={onClosePopover}
      open={isPopoverVisible}
      wrapWithTypography={false}
    >
      <div className="filter-popover__content">
        <AccordionComponent accordionDataList={filterAccordionList} />
        <ButtonComponent
          text="Clear all filters"
          onClick={clearAllFilter}
          variant={'outlined'}
          color="default"
        />
      </div>
    </PopoverComponent>
  );
});
CapacityStoreFilterPopover.displayName = 'CapacityStoreFilterPopover';
CapacityStoreFilterPopover.whyDidYouRender = true;
export { CapacityStoreFilterPopover };
